import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  danhSachNguoiDungTheoDanhSachDonVi: [],
  danhSachVaiTroTheoNguoiDung: [],
  danhSachGroupTheoNguoiDung: [],
  danhSachVaiTroKhongThuocNguoiDung: [],
  danhSachGroupKhongThuocNguoiDung: [],
  danhSachQuyenTheoNguoiDung: [],
  danhSachQuyenKhongThuocNguoiDung: [],
  chiTietNguoiDung: {},
  nguoiDungGomQuyen: {},
  danhSachNguoiDungTheoGroup: [],
  danhSachNguoiDungKhongThuocVaiTro: [],
  danhSachNguoiDungTheoVaiTro: [],
  danhSachCanBoLayVaoNguoiDung: [],
};
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
